import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function SuperSubscriptionInvoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/super/subscription-invoices").then(({ data }) => setItems(data)); }, []);

  return (
    <div className="space-y-6" data-testid="super-sub-invoices-page">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">Billing</div>
        <h1 className="font-serif text-4xl tracking-tighter mt-1 text-white">Subscription invoices</h1>
      </div>

      <div className="bg-[#18181B] border border-white/5 rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-white/5"><TableHead className="text-zinc-400">Invoice</TableHead><TableHead className="text-zinc-400">Company</TableHead><TableHead className="text-zinc-400">Plan</TableHead><TableHead className="text-zinc-400">Period</TableHead><TableHead className="text-zinc-400 text-right">Amount</TableHead><TableHead className="text-zinc-400">Status</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={6} className="text-center text-sm text-zinc-500 py-10">No subscription invoices yet.</TableCell></TableRow>
            ) : items.map((i) => (
              <TableRow key={i.id} className="border-white/5 hover:bg-white/5" data-testid={`super-inv-row-${i.id}`}>
                <TableCell className="text-zinc-200">{i.invoice_number}</TableCell>
                <TableCell className="text-zinc-300">{i.company_name}</TableCell>
                <TableCell className="text-zinc-300">{i.plan_name}</TableCell>
                <TableCell className="text-zinc-400 text-xs">{(i.period_start || "").slice(0,10)} → {(i.period_end || "").slice(0,10)}</TableCell>
                <TableCell className="text-right text-zinc-200">{i.currency} {(i.amount || 0).toLocaleString()}</TableCell>
                <TableCell><Badge variant="outline" className="bg-emerald-900/40 text-emerald-300 border-emerald-800 capitalize">{i.status}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
